import { useQuery } from "react-query";
import { getSiteAdmin } from "../../../../actions/CarrierAgreementMgmt/Security";

export const useSiteAdmin = () => {
  const { data, isLoading, refetch } = useQuery("GetSiteAdmin", getSiteAdmin, {
    refetchOnWindowFocus: false,
  });

  return { data, isLoading, refetch };
};
